function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodesConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.302 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.657 25a2.405 2.405 0 0 0-3.473-1.241l-2.118-2.65a1.9 1.9 0 0 0 .12-.219 1.882 1.882 0 1 0-.621.744l2.057 2.574a2.378 2.378 0 0 0-.6 2.12l-3.07 1.117a1.852 1.852 0 0 0-1.586-.9 1.862 1.862 0 0 0-1.691 1.088 1.857 1.857 0 1 0 3.524.486L27.272 27a2.417 2.417 0 0 0 4.385-2zM23.4 28.874a1.137 1.137 0 0 1-2.1-.073 1.124 1.124 0 0 1 .03-.87 1.134 1.134 0 0 1 1.506-.563 1.136 1.136 0 0 1 .563 1.506z",
    transform: "translate(-20.51 -18.261)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodesConnection);
export default __webpack_public_path__ + "static/media/nodes-connection.6619d994.svg";
export { ForwardRef as ReactComponent };